import { motion } from "framer-motion";
import { Play } from "lucide-react";

const fade = (delay) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  return (
    <section
      className="relative pt-28 sm:pt-32 pb-14 px-5 sm:px-8 lg:px-12 overflow-hidden"
      data-testid="hero-section"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-8 items-center lg:min-h-[calc(100vh-10rem)] max-w-[1500px] mx-auto">
        {/* Headline stack */}
        <div className="lg:col-span-8 min-w-0">
          <motion.p {...fade(0)} className="overline-tcc mb-7" data-testid="hero-overline">
            Truths, Chaos &amp; Cupcakes — A Savi Coliving Podcast
          </motion.p>

          <h1 className="font-display leading-[0.9] break-words">
            <motion.span
              {...fade(0.1)}
              className="block text-[2.6rem] sm:text-6xl md:text-7xl xl:text-8xl text-[#F4F2EE]"
            >
              Success is a myth.
            </motion.span>
            <motion.span
              {...fade(0.22)}
              className="block text-[2.6rem] sm:text-6xl md:text-7xl xl:text-8xl text-stroke"
            >
              Chaos is a guarantee.
            </motion.span>
          </h1>
          <motion.p
            {...fade(0.34)}
            className="font-serif-tcc italic text-4xl sm:text-5xl xl:text-6xl text-[#FF3E8A] mt-4 lg:mt-6"
          >
            Have a cupcake.
          </motion.p>

          <motion.p
            {...fade(0.46)}
            className="text-base sm:text-lg text-[#9494A6] max-w-md mt-9 font-light leading-relaxed"
          >
            Honest conversations from the messy middle of making it —
            recorded in the mountains of Valencia.
          </motion.p>

          {/* CTAs */}
          <motion.div {...fade(0.58)} className="flex flex-wrap gap-3 sm:gap-4 mt-9">
            <a
              href="https://www.youtube.com/@TruthsChaosCupcakes"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brutal"
              data-testid="hero-youtube-btn"
            >
              <Play size={14} fill="currentColor" />
              Watch Episodes
            </a>
            <a href="#be-a-guest" className="btn-brutal-ghost" data-testid="hero-about-btn">
              Be a Guest
            </a>
          </motion.div>
        </div>

        {/* Opening video — brand intro on loop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.1, delay: 0.4 }}
          className="lg:col-span-4"
        >
          <div className="relative border border-[#232332] overflow-hidden">
            <video
              src="/opening-video.mp4"
              poster="/og-image.png"
              autoPlay
              muted
              loop
              playsInline
              className="w-full aspect-video object-cover"
              data-testid="hero-video"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
